import React, { useState, useEffect } from 'react'
import LandingPage from './LandingPage'
import CareerSurvey from './CareerSurvey'
import quizData from './short_questions.json'

const CareerQuiz = () => {
    const [hasStarted, setHasStarted] = useState(false);
    const [imagesPreloaded, setImagesPreloaded] = useState(false);

    useEffect(() => {
        // Extract all image URLs
        const imageUrls = [
            ...(quizData.parta || []).map(q => q.imgurl),
            ...(quizData.partb || []).map(q => q.imgurl)
        ].filter(url => url);

        if (imageUrls.length === 0) {
            setImagesPreloaded(true);
            return;
        }

        let loadedCount = 0;
        const total = imageUrls.length;

        const handleLoad = () => {
            loadedCount++;
            if (loadedCount === total) {
                setImagesPreloaded(true);
            }
        };

        imageUrls.forEach(url => {
            const img = new Image();
            img.src = url;
            img.onload = handleLoad;
            img.onerror = handleLoad; // Proceed even if some fail
        });
    }, []);

    return (
        <>
            {!hasStarted ? (
                <LandingPage
                    onStart={() => setHasStarted(true)}
                    imagesPreloaded={imagesPreloaded}
                />
            ) : (
                <CareerSurvey />
            )}
        </>
    )
}

export default CareerQuiz